import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, first, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { GeneralError } from 'vidis-common';
import { MedicationSchemeResult } from 'vidis-common/medication';
import { selectPatientSSIN } from '../selectors/user.selector';
import { MedicationService } from './../../services/medication/medication.service';

import * as medicationSchemeActions from 'src/app/store/actions/medication.action';
import * as userActions from 'src/app/store/actions/user.action';
import { selectMedicationSchemeIsLoaded } from '../selectors/medication.selector';

@Injectable()
export class MedicationSchemeEffects {
    constructor(
        private actions$: Actions,
        private medicationService: MedicationService,
        private store: Store
    ) {}

  fetchMedicationScheme$ = createEffect(() => this.actions$.pipe(
    ofType(medicationSchemeActions.fetchMedicationScheme),
    withLatestFrom(
      this.store.select(selectPatientSSIN),
      this.store.select(selectMedicationSchemeIsLoaded)
    ),
    switchMap(([action, ssin, isLoaded]) => {
      if (!isLoaded && ssin !== undefined) {
        return this.medicationService.getPatientMedicationScheme(ssin)
          .pipe(
            switchMap((medicationScheme: MedicationSchemeResult) => [
              medicationScheme.errors?.length > 0
                ? medicationSchemeActions.setMedicationErrorAction({medicationErrors: medicationScheme.errors})
                : medicationSchemeActions.clearMedicationErrorAction(),
              medicationSchemeActions.setMedicationAction({medicationSchemes: medicationScheme.schemes})
            ]),
            catchError((err: HttpErrorResponse) =>
              {
                let medicationError: GeneralError = {code: 'VIDIS_0400'};
                if (err.status === 0) {
                  medicationError.code = 'network_error';
                } else if (err?.error?.code?.includes('VIDIS')) {
                  medicationError = err.error;
                }
                medicationError.traceId = err.headers?.get('trace-id');

                return of(medicationSchemeActions.setMedicationErrorAction({medicationErrors:[medicationError]}
                ));
              }
            )
          )
      }
      return EMPTY;
    })));

    updatePatientNameFromMedicationScheme$ = createEffect(() => this.actions$.pipe(
        ofType(medicationSchemeActions.setMedicationAction),
        filter(content => content.medicationSchemes?.length > 0),
        switchMap(content => of(userActions.setPatientAction({patient: content.medicationSchemes[0].patient})))
    ));
}
